import { UserManager, WebStorageStateStore, type UserManagerSettings } from 'oidc-client-ts';
import { appConfig } from './authConfig';

const baseRedirect = `${window.location.origin}`;

export const oidcSettings: UserManagerSettings = {
  authority: appConfig.oidcIssuer,
  client_id: appConfig.oidcClientId,
  redirect_uri: `${baseRedirect}/auth/callback`,
  silent_redirect_uri: `${baseRedirect}/auth/silent-callback`,
  post_logout_redirect_uri: `${baseRedirect}/`,
  response_type: 'code',
  scope: 'openid profile email roles',
  automaticSilentRenew: true,
  loadUserInfo: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  monitorSession: false,
};

export const userManager = new UserManager(oidcSettings);

userManager.events.addAccessTokenExpiring(() => {
  void userManager.signinSilent().catch(() => {
    /* ignored — user gets re-prompted via 401 handler */
  });
});

userManager.events.addSilentRenewError(() => {
  /* logged silently — surfaced via auth state */
});
